import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class OurJourney extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (
        <div className='journey '> 
  
     <section className="bg-special">
  <div className="history">
    <div className="timeline">

      {/* 2014 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={JSON.parse(localStorage.getItem("settings")).site_logo}
            className="j-image"
            alt="Founded Logo"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2015
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          FOUNDED
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We were founded and registered in the United Arab Emirates with Head
          Quarters in Abu Dhabi with 100% Emirati ownership.
        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2018 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/value_ecebae8c1c.svg`}
            className="j-image"
            alt="Value Added Icon"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2018
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          VALUE ADDED
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We explored and added value services with organic growth across the GCC
          region and coverage to the wider Middle-East region.
        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2019 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/legacy_3e7072949f.svg`}
            className="j-image"
            alt="Legacy Icon"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2019
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          LEGACY
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We have established ourselves as a trusted trading, procuremen, and supply partner to the Aviation and Oil & Gas 
sectors, providing helideck equipment, safety systems, and specialized products that support critical operations.

        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2020 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/training_45e962c582.svg`}
            className="j-image"
            alt="Training Icon"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2020
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          GROWTH & ACTVET
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We introduced a centre of excellence in our service fields under ACTVET
          License for Training and Competency.
        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2021 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/drones_e5640e9e83.svg`}
            className="j-image"
            alt="Drones Icon"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2021
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          DRONES
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We explore unmanned aircraft systems (UAS) to introduce more added
          value services including digitalisation, automation and academic
          research & development.
        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2022 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/tech_5a102e87cd.svg`}
            className="j-image"
            alt="Technology Icon"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2022
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          TECHNOLOGY DRIVE
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We invested into technologically advanced equipment to drive industry
          innovation with focus on Drones Services.
        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* 2023 */}
      <div className="milestone" type="depth">
        <div data-aos="fade-down" data-aos-duration="1000" className="image">
          <img
            src={base_url+`assets/_nuxt/img/africa_ac65439f76.svg`}
            className="j-image"
            alt="Africa Expansion"
          />
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="year">
          2023
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="title">
          ESTA GROWTH
        </div>

        <div data-aos="fade-down" data-aos-duration="1000" className="description">
          We have strengthened our global sourcing capabilities through strategic partnerships 
          and customized manufacturing solutions across leading Asian production hubs, enabling us to deliver quality products, 
          competitive pricing, and reliable supply chain support.

        </div>

        <div data-aos="flip-down" data-aos-duration="1000" className="historyline"></div>
      </div>

      {/* Final Section */}
      <div className="milestone">
        <div data-aos="fade-up" data-aos-duration="1000" className="year">
          <img src={base_url+`assets/_nuxt/img/infinity.8c9eaa1.gif`} alt="Infinity" />
          <br />
        </div>

        <div data-aos="fade-up" data-aos-duration="1100" className="title">
          We're just getting started
        </div>

        <div data-aos="fade-up" data-aos-duration="1100" className="description">
          Our journey continues and we look forward to what the future holds.
          Join us for the ride!
        </div>
      </div>

    </div>
  </div>
</section>

       </div>

    );
}

}

export default OurJourney;